import * as React from 'react';

import { CommonBadge } from './baseBadge';

interface ICourtShiftBadgeProps {
    offset: number;
}

export const CourtShiftBadge = (props: ICourtShiftBadgeProps) => {
    if (!props.offset) return null;
    const style: React.CSSProperties = {
        height: `${CommonBadge.getBadgeHeightByDuration(props.offset)}px`,
    };
    return (
        <div style={style} className='table-column-item-wrapper shift-cell'>
            <div className='table-column-item' />
        </div>
    );
};
